module.exports = __webpack_public_path__ + "static/nobox-blue-357f39973d0429cd20f5693e8d463649.png";